import React, { useState } from "react";
import "./datatable.scss";
import { ProgressBar } from "react-bootstrap";
import { formatDecimal } from "../../../../utils/formatDecimal";
import EditProject from "./EditProject";

const DataTable = ({ data, handleToggle, getData, isAdmin }) => {
  const [activeTab, setActiveTab] = useState("home-tab");
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);

  };

  // console.log(data, "data in datatable")

  return (
    <>
      <section className="datatable">
        <div className="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>
                  <div className="parent-tag">
                    Date Added
                    <div className="filter-btn" style={{ cursor: "pointer" }}>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill="#77868B"
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill="#77868B"
                        />
                      </svg>
                    </div>
                  </div>
                </th>
                <th>Projects</th>
                <th>Purchase Limit</th>
                <th>Buy Limit Per User</th>
                <th>Users Purchased</th>
                <th>Credits Consumed</th>
                {isAdmin &&   <th className="text-center">Pause Buys</th>}
                {isAdmin &&   <th className="text-center">Edit</th>}
              </tr>
            </thead>
            <tbody>


              {data?.map((item) => {
                return (
                  <tr>
                    <td>
                      <div className="twice-text">
                        <h6>{new Date(item?.createdAt)?.toLocaleDateString()}</h6>
                        <p>{new Date(item?.createdAt)?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                      </div>
                    </td>
                    <td>
                      <div className="maintoken">
                        <div className="tokenimg">

                          <img
                            src={`/assets/${item.privateSale?.toLowerCase()}.svg`}
                            alt="innerimg"
                            className="innerimg"
                          />
                        </div>
                        <p className="tokenpara">{item.privateSale}</p>
                        {/* {
                           console.log("item.privateSale",item.privateSale)
                        } */}
                      </div>
                    </td>
                    <td>
                      <div className="progressmain">
                        <div className="progressheadings">
                          <p className="token"> {formatDecimal( item?.creditConsumed[0]?.tokenPurchased) } {item?.privateSale}</p>
                          <h6 className="tokenright">{item?.purchaseLimit} {item?.privateSale}</h6>
                        </div>
                        <ProgressBar now={
                          item?.purchaseLimit > 0
                            ? (item?.creditConsumed?.[0]?.tokenPurchased || 0) / item.purchaseLimit * 100
                            : 0
                        } />
                        {/* <ProgressBar now={60} /> */}
                      </div>
                    </td>
                    <td>{item?.purchaseLimitPerUser || 0} {item.privateSale}</td>
                    <td>{item?.usersCount[0]?.usersCount || 0}</td>
                    <td>{formatDecimal(item?.creditConsumed[0]?.creditRefunded) || 0} </td>
                    {isAdmin && <td>
                      <div className="parent-toggle-switch-custom tabletoggle">
                        <div className="custom-toggle">
                          <input
                            type="checkbox"
                            className="checkbox"
                            id={`checkbox-${item?._id}`}
                            checked={item?.isActive}
                            onChange={() => handleToggle(item?._id)}
                          />
                          <label className="switch" htmlFor={`checkbox-${item?._id}`}>
                            <span className="slider"></span>
                          </label>
                        </div>
                      </div>
                    </td>}
                    {isAdmin && <td className="text-center">
                      <EditProject data={item} getData={getData}/>
                    </td>}

                  </tr>

                )
              })
              }
{/* 
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="twice-text">
                    <h6>03/09/2024</h6>
                    <p>5:14</p>
                  </div>
                </td>
                <td>
                  <div className="maintoken">
                    <div className="tokenimg">
                      <img
                        src="/assets/claim/eth.svg"
                        alt="innerimg"
                        className="innerimg"
                      />
                    </div>
                    <p className="tokenpara">Matchchain</p>
                  </div>
                </td>
                <td>
                  <div className="progressmain">
                    <div className="progressheadings">
                      <p className="token">5,000,000 DOP</p>
                      <h6 className="tokenright">200,000 DOP</h6>
                    </div>
                    <ProgressBar now={60} />
                  </div>
                </td>
                <td>5,000,000 DOP</td>
                <td>2.5K</td>
                <td>1.25 M</td>
                <td>
                  <div className="parent-toggle-switch-custom tabletoggle">
                    <div class="custom-toggle">
                      <input type="checkbox" class="checkbox" id="checkbox" />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                </td>
              </tr> */}
            </tbody>
          </table>

        </div>
        {/* <div className="footer-content">
          <div className="left-f">
            <h6>SHOWING 1-10 OF 145</h6>
          </div>
          <div className="right-f">
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item">
                  <a class="page-link" href="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                    >
                      <path
                        d="M7.88904 2.43555L5.38763 2.43555L1.99459 8.49682L4.496 8.49682L7.88904 2.43555Z"
                        fill="#869397"
                      />
                      <path
                        d="M7.88904 14.5703L5.38763 14.5703L1.99459 8.50904L3.57108 7.46117L4.496 8.50904L7.88904 14.5703Z"
                        fill="#869397"
                      />
                      <path
                        d="M8.01655 7.35742H14.9616L13.6869 9.64313H6.74182L8.01655 7.35742Z"
                        fill="#869397"
                      />
                    </svg>
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link active" href="#">
                    1
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    2
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    3
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    4
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    5
                  </a>
                </li>
                <li class="page-item">
                  <a class="page-link" href="#">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                    >
                      <path
                        d="M9.11108 2.43555L11.6125 2.43555L15.0055 8.49682L12.5041 8.49682L9.11108 2.43555Z"
                        fill="#329879"
                      />
                      <path
                        d="M9.11108 14.5703L11.6125 14.5703L15.0055 8.50904L13.429 7.46117L12.5041 8.50904L9.11108 14.5703Z"
                        fill="#329879"
                      />
                      <path
                        d="M3.31318 7.35742H10.2582L8.98351 9.64313H2.03845L3.31318 7.35742Z"
                        fill="#329879"
                      />
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default DataTable;
